type EventData = Record<string, string | number | boolean | undefined>;

declare global {
    interface Window {
        umami?: {
            track: (name: string, data?: EventData) => void;
        };
    }
}

export const trackEvent = (name: string, data?: EventData) => {
    if (typeof window === 'undefined') return;
    window.umami?.track(name, {
        page: window.location.pathname,
        ...data,
    });
};

export {};
